/**
 * HomePage — thin wrapper that always renders the TodaysPulse hero.
 *
 * History (iter 60.1): the legacy 6-bubble grid + magenta-pink-orange "Continue →"
 * CTA was removed entirely. TodaysPulse handles both premium and free states
 * internally (premium gets the live hero with movers/health/story; free gets a
 * compact upgrade CTA).
 */
import TodaysPulse from './TodaysPulse';

export default function HomePage({ onTopicClick, user, onOpenPortfolio, onBrowseAll }) {
  return (
    <TodaysPulse
      user={user}
      onTopicClick={onTopicClick}
      onOpenPortfolio={onOpenPortfolio || onBrowseAll}
    />
  );
}
